export default "__VITE_ASSET__COnGwQ5K__"